import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { ApplicationStateService } from './services/application-state.service';
import { AuthService as AuthGuard } from './services/auth.service';
import { BillingAddressComponent } from './components/billing-address/billing-address.component';
import { AiChatComponent } from './components/ai-chat/ai-chat.component';




/*  export function mobile(url: UrlSegment[]) {
  if(window.innerWidth<=768){
    return ({ consumed: url, posParams: {page : 'account'} });
}else{
  return null;
}
}
export function desktop(url: UrlSegment[]) {
  if(window.innerWidth<=768){
    return ({ consumed: url, posParams: {page : 'account'} });
}else{
  return null;
}
} 


} */

const routes: Routes = [
  // {
  // path: "", component: AppComponent, children: [
  {
    path: "",
    loadChildren: () => import('./pages/homepage/homepage.module').then(m => m.HomepageModule)
  },
  {
    path: "home",
    loadChildren: () => import('./pages/homepage/homepage.module').then(m => m.HomepageModule)
  },

  {
    path: 'chat-with-ai',
    component: AiChatComponent

  },
  {
    path: 'callback',
    loadChildren: () => import('src/app/components/callback/callback.module').then(m => m.CallbackModule)
  }
  ,
  {
    path: 'support',
    loadChildren: () => import('./support/support.module').then(m => m.SupportModule)
  },
  {
    path: "hardwares",
    loadChildren: () => import('./pages/hardwares/hardwares.module').then(m => m.HardwaresModule)
  },
  {
    path: 'gps-product',
    loadChildren: () => import('./product-view/product-view.module').then(m => m.ProductViewModule)
  },
  {
    path: "gps-tracking-devices/:id",
    loadChildren: () => import('src/app/components/product-detail/product-detail.module').then(m => m.ProductDetailModule)
  },
  {
    path: "gps-tracking-devices",
    loadChildren: () => import('./pages/hardwares/gpstrackers/gpstrackers.module').then(m => m.GpstrackersModule)
  },
  {
    path: "heavy-equipments",
    loadChildren: () => import('./pages/heavy-equipments/heavy-equipments.module').then(m => m.HeavyEquipmentsModule)
  },
  {
    path: "logistics",
    loadChildren: () => import('./pages/logistics/logistics.module').then(m => m.LogisticsModule)
  },
  {
    path: "municipal",
    loadChildren: () => import('./pages/logistics/logistics.module').then(m => m.LogisticsModule)
  },
  {
    path: "drones",
    loadChildren: () => import('./pages/logistics/logistics.module').then(m => m.LogisticsModule)
  },
  {
    path: "rentalbikes",
    loadChildren: () => import('./pages/logistics/logistics.module').then(m => m.LogisticsModule)
  },
  {
    path: "delivery",
    loadChildren: () => import('./pages/delivery/delivery.module').then(m => m.DeliveryModule)
  },
  {
    path: "checkout",
    loadChildren: () => import('./pages/checkout-process/checkout-process.module').then(m => m.CheckoutProcessModule)
  },
  {
    path: 'account',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/account/account.module').then(m => m.AccountModule)
  },
  {
    path: 'my-account',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/account/my-account-mobile/my-account/my-account.module').then(m => m.MyAccountModule)
  },
  {
    path: "contact-us",
    loadChildren: () => import('./components/footer/contact-us/contact-us.module').then(m => m.ContactUsModule)
  },
  {
    path: "cookies-policy",
    loadChildren: () => import('./components/footer/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule)
  },
  {
    path: "privacy-policy",
    loadChildren: () => import('./components/footer/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule)
  },
  {
    path: "terms-and-conditions",
    loadChildren: () => import('./components/footer/terms-and-conditions/terms-and-conditions.module').then(m => m.TermsAndConditionsModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/log-in/log-in.module').then(m => m.LogInModule)
  },
  {
    path: 'signup',
    loadChildren: () => import('./pages/sign-up/sign-up.module').then(m => m.SignUpModule)
  },
  {
    path: "order-and-address",
    canActivate: [AuthGuard],
    loadChildren: () => import('./order-and-address/order-and-address.module').then(m => m.OrderAndAddressModule)
  },
  {
    path: 'order-success',
    // canActivate: [AuthGuard] , 
    loadChildren: () => import('./pages/checkout-process/order-success/order-success.module').then(m => m.OrderSuccessModule)
  },
  {
    path: 'cart',
    loadChildren: () => import('./pages/cart-mobile/cart-mobile.module').then(m => m.CartMobileModule)
  },
  {
    path: "coupon",
    loadChildren: () => import('./coupon/coupon.module').then(m => m.couponModule)
  },
  {
    path: 'refer',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/refer/refer.module').then(m => m.ReferModule)
  },

  {
    path: 'quickbuy',
    loadChildren: () => import('./quick-url/quick-url.module').then(m => m.QuickUrlModule)
  },

  {
    path: 'request',
    loadChildren: () => import('./request-address/request-address.module').then(m => m.RequestAddressModule)
    // canActivate: [AuthGuard]
  },
  {
    path: "shipper/:orderNumber",
    component: BillingAddressComponent
  },
  {
    path: 'review/:id',
    canActivate: [AuthGuard],
    loadChildren: () => import('./components/review/review.component.module').then(m => m.ReviewModule)
  },
  {
    path: 'recharge-now',
    loadChildren: () => import('./recharge/recharge.module').then(m => m.RechargeModule)
  },
  {
    path: 'order-detail',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/checkout-process/order-success/order-success.module').then(m => m.OrderSuccessModule),
  },
  {
    path: 'order',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/checkout-process/order-success/order-success.module').then(m => m.OrderSuccessModule),
  },
  {
    path: 'invoice/:id',
    loadChildren: () => import('./components/invoice-management/invoice-management.module').then(m => m.InvoiceManagementModule)
  },
  {
    path: 'orders',
    loadChildren: () =>
      import('./pages/account/my-account-mobile/orders-mobile/orders-mobile.module').then(m => m.OrdersMobileModule)
  }
  ,
  {
    path: 'order-detail/:orderNo',
    loadChildren: () =>
      import('./pages/checkout-process/order-success/order-success.module').then(m => m.OrderSuccessModule)
  }
  ,
  {
    path: 'gps-tracker-scooty',
    loadChildren: () => import('./components/product-detail/product-detail.module').then(m => m.ProductDetailModule)
  },
  {
    path: 'gps-tracker-bike',
    loadChildren: () => import('./components/product-detail/product-detail.module').then(m => m.ProductDetailModule)
  },
  {
    path: 'gps-tracker-truck',
    loadChildren: () => import('./components/product-detail/product-detail.module').then(m => m.ProductDetailModule)
  },
  {
    path: 'gps-tracker-car',
    loadChildren: () => import('./components/product-detail/product-detail.module').then(m => m.ProductDetailModule)
  },
  {
    path: 'gps-tracker-bus',
    loadChildren: () => import('./components/product-detail/product-detail.module').then(m => m.ProductDetailModule)
  },
  {
    path: 'gps-tracker-kids',
    loadChildren: () => import('./components/product-detail/product-detail.module').then(m => m.ProductDetailModule),
  },
  {
    path: 'gps-tracker-asset',
    loadChildren: () => import('./components/product-detail/product-detail.module').then(m => m.ProductDetailModule),
  },
  {
    path: 'raghav-vlogs',
    loadChildren: () => import('./components/product-detail/product-detail.module').then(m => m.ProductDetailModule)
  },
  {
    path: 'shipper',
    loadChildren: () => import('./shipper/shipper.module').then(m => m.ShipperModule)
  },

  /*{
    path:'affiliate',
    loadChildren:()=>import('./components/affiliate/affiliate.module').then(m=>m.AffiliateModule)
  },*/
  {
    path: '**',
    loadChildren: () => import('./pages/page-not-found/page-not-found.module').then(m => m.PageNotFoundModule)
  },


  //     ]

  // },




];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, -750],
  })],
  exports: [RouterModule],
  providers: [ApplicationStateService]
})
export class AppRoutingModule { }